import type { SupportedLocale } from './localize.js';

export const localizedPages: Record<string, Record<SupportedLocale, string>> = {
  breviary: {
    it: 'breviario',
    en: 'breviary',
    de: 'brevier',
    pt: 'breviario',
  },
  invitatory: {
    it: 'invitatorio',
    en: 'invitatory',
    de: 'invitatorium',
    pt: 'invitatory',
  },
  matins: {
    it: 'ufficio',
    en: 'matins',
    de: 'lesehore',
    pt: 'matins',
  },
  lauds: {
    it: 'lodi',
    en: 'lauds',
    de: 'laudes',
    pt: 'lauds',
  },
  terce: {
    it: 'terza',
    en: 'terce',
    de: 'terz',
    pt: 'terce',
  },
  sext: {
    it: 'sesta',
    en: 'sext',
    de: 'sext',
    pt: 'sext',
  },
  none: {
    it: 'nona',
    en: 'none',
    de: 'non',
    pt: 'none',
  },
  vespers: {
    it: 'vespri',
    en: 'vespers',
    de: 'vesper',
    pt: 'vespers',
  },
  compline: {
    it: 'compieta',
    en: 'compline',
    de: 'komplet',
    pt: 'compline',
  },
  songs: {
    it: 'canti',
    en: 'songs',
    de: 'lieder',
    pt: 'cancoes',
  },
  search: {
    it: 'cerca',
    en: 'search',
    de: 'suche',
    pt: 'pesquisa',
  },
  prayers: {
    it: 'preghiere',
    en: 'prayers',
    de: 'gebete',
    pt: 'oracoes',
  },
  magazines: {
    it: 'riviste',
    en: 'magazines',
    de: 'zeitschriften',
    pt: 'revistas',
  },
  'ancilla-domini': {
    it: 'ancilla-domini',
    en: 'ancilla-domini',
    de: 'ancilla-domini',
    pt: 'ancilla-domini',
  },
  sempreconnessi: {
    it: 'sempreconnessi',
    en: 'sempreconnessi',
    de: 'sempreconnessi',
    pt: 'sempreconnessi',
  },
  'holy-mass': {
    it: 'santa-messa',
    en: 'holy-mass',
    de: 'heilige-messe',
    pt: 'santa-missa',
  },
  settings: {
    it: 'impostazioni',
    en: 'settings',
    de: 'einstellungen',
    pt: 'configuracoes',
  },
  info: {
    it: 'informazioni',
    en: 'info',
    de: 'informationen',
    pt: 'informacoes',
  },
  latest: {
    it: 'ultimo',
    en: 'latest',
    de: 'neueste',
    pt: 'mais-recentes',
  },
};

export const localizeHref = (
  locale: SupportedLocale,
  page = 'home',
  ...subroutes: (string | number)[]
) => {
  const localizedPage = localizedPages[page]?.[locale];
  const subroute =
    subroutes.length > 0
      ? `/${subroutes
          .map((subroute) => localizedPages[subroute]?.[locale] || subroute)
          .join('/')}`
      : '';

  return `/${locale}${localizedPage ? `/${localizedPage}${subroute}` : ''}`;
};
